import React from 'react';

import { NavigationAgentSessions as NavigationAgentSessionsProvider } from '@atlassian/rovo-navigation/NavigationAgentSessions';

import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';
import { fg } from '@townsquare/stat-sig/gate';

export const NavigationAgentSessions = (
	props: React.ComponentProps<typeof NavigationAgentSessionsProvider>,
): React.JSX.Element =>
	fg('rovo-chat-ai-inbox') ? (
		<AggRelayEnvironmentProvider>
			<NavigationAgentSessionsProvider {...props} />
		</AggRelayEnvironmentProvider>
	) : (
		<>{props.children}</>
	);
